import { useZodForm } from "popopo-lib-front/zod-form"
import { z } from "zod/v4"
import { LoadingButton, ManagedCheckbox } from "popopo-lib-front/component"
import { Stack } from "react-bootstrap"
import { api } from "../../core"
import { User } from "firebase/auth"
import { useState } from "react"
import { useToast } from "popopo-lib-front/hook"
import { UserId, UserSettingDocument } from "popopo-msg"

export const TargetUserSettingForm = (props: {
  firebase: User
  targetUserId: UserId
  initialData: UserSettingDocument | null
}) => {
  const toast = useToast()
  const form = useZodForm({
    schema: z.object({
      acceptPush: z.boolean(),
      acceptCall: z.boolean(),
      acceptSuperCall: z.boolean(),
    }),
    defaultValues: {
      acceptPush: props.initialData?.accept_push ?? true,
      acceptCall: props.initialData?.accept_call ?? true,
      acceptSuperCall: props.initialData?.accept_super_call ?? false,
    }
  })
  const { isValid } = form.formState

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [result, setResult] = useState<string | null>(null)

  return (
    <form onSubmit={form.handleSubmit(async (data) => {
      setIsSubmitting(true)
      setResult(null)
      try {
        const res = await api.PUT("/api/v2/users/me/user-settings/{targetUserId}", {
          params: {
            path: { targetUserId: props.targetUserId }
          },
          body: {
            acceptPush: data.acceptPush,
            acceptCall: data.acceptCall,
            acceptSuperCall: data.acceptSuperCall,
          },
          headers: {
            authorization: `Bearer ${await props.firebase.getIdToken()}`
          }
        })
        if (res.data == null) {
          toast.add({
            type: "danger",
            title: "ユーザー設定の更新に失敗しました",
            message: JSON.stringify(res.error)
          })
          setResult(`Error: ${JSON.stringify(res.error)}`)
        } else {
          toast.add({
            type: "success",
            title: "ユーザー設定",
            message: "更新しました"
          })
          setResult(`Success: ${JSON.stringify(res.data)}`)
        }
      } catch (e) {
        console.error(e)
        const errorMessage = e instanceof Error ? e.message : String(e)
        toast.add({
          type: "danger",
          title: "ユーザー設定の更新に失敗しました",
          message: errorMessage
        })
        setResult(`Error: ${errorMessage}`)
      } finally {
        setIsSubmitting(false)
      }
    })}>
      <Stack gap={2}>
        <div className="mb-2">
          <strong>対象ユーザーID:</strong> {props.targetUserId}
        </div>
        <ManagedCheckbox control={form.control} name="acceptPush" checkboxLabel="プッシュ通知を受信する" />
        <ManagedCheckbox control={form.control} name="acceptCall" checkboxLabel="コールを受信する" />
        <ManagedCheckbox control={form.control} name="acceptSuperCall" checkboxLabel="スーパーコールを受信する" />
        <LoadingButton isLoading={isSubmitting} isValid={isValid}>
          更新
        </LoadingButton>
        {result && (
          <pre className="mt-2 p-2 bg-light border rounded" style={{ whiteSpace: "pre-wrap", wordBreak: "break-all" }}>
            {result}
          </pre>
        )}
      </Stack>
    </form>
  )
}
